import React, { useState, useEffect } from 'react';
import Header from '../homepage/header'; // Adjust the path if needed
import { API_BASE } from '../../apiConfig';
import publicationsData from './publicationsAndPatents.json'; // Import the JSON file
import './Publications.css';

const mapStaticToDb = (staticData) => {
  const mapped = {};
  Object.entries(staticData).forEach(([category, items]) => {
    mapped[category] = items.map(item => ({
      title: item.Title || '',
      authors: item.Authors || '',
      bookTitle: item["Book Title"] || '',
      publisher: item.Publisher || '',
      journal: item.Journal || '',
      conference: item.Conference || '',
      year: item.Year || '',
      volume: item.Volume || '',
      pages: item.Pages || '',
      impactFactor: item["Impact Factor"] || '',
      indexing: item.Indexing || '',
      doi: item.DOI || '',
      isbn: item.ISBN || '',
      award: item.Award || '',
      inventors: item.Inventors || '',
      applicationNo: item["Application No."] || item.applicationNo || '',
      dateOfFiling: item["Date of Filing"] || item.dateOfFiling || '',
      link: item.Link || item.link || ''
    }));
  });
  return mapped;
};

function Publications() {
  const [publicationsList, setPublicationsList] = useState({});
  const [expandedSections, setExpandedSections] = useState({});

  useEffect(() => {
    fetch(`${API_BASE}/publications`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then((data) => setPublicationsList(data))
      .catch((err) => {
        console.log("Failed fetching dynamic publications, falling back to static:", err);
        setPublicationsList(mapStaticToDb(publicationsData));
      });
  }, []);

  const toggleSection = (category) => {
    setExpandedSections((prevSections) => ({
      ...prevSections,
      [category]: !prevSections[category],
    }));
  };

  return (
    <div>
      <Header />
      <div className="header-container">
        <h1>Publications & Patents</h1>
      </div>
      <div className="publications-container">
        {Object.entries(publicationsList).map(([category, items]) => (
          <div key={category} className="category">
            <h2 onClick={() => toggleSection(category)} className="expandable-heading">
              {category}
              <span className={`chevron ${expandedSections[category] ? 'rotate' : ''}`}>
                {expandedSections[category] ? '▲' : '▼'}
              </span>
            </h2>
            {expandedSections[category] && (
              <div className="items-grid">
                {items.map((item, index) => (
                  <div className="item" key={index}>
                    <h3>{item.title}</h3>
                    {item.authors && <p><strong>Authors:</strong> {item.authors}</p>}
                    {item.bookTitle && <p><strong>Book:</strong> {item.bookTitle}</p>}
                    {item.publisher && <p><strong>Publisher:</strong> {item.publisher}</p>}
                    {item.journal && <p><strong>Journal:</strong> {item.journal}</p>}
                    {item.conference && <p><strong>Conference:</strong> {item.conference}</p>}
                    {item.year && <p><strong>Year:</strong> {item.year}</p>}
                    {item.volume && <p><strong>Volume:</strong> {item.volume}</p>}
                    {item.pages && <p><strong>Pages:</strong> {item.pages}</p>}
                    {item.impactFactor && (
                      <p><strong>Impact Factor:</strong> {item.impactFactor}</p>
                    )}
                    {item.indexing && <p><strong>Indexing:</strong> {item.indexing}</p>}
                    {item.isbn && <p><strong>ISBN:</strong> {item.isbn}</p>}
                    {item.doi && <p><strong>DOI:</strong> {item.doi}</p>}
                    {item.award && <p><strong>Award:</strong> {item.award}</p>}
                    {item.dateOfFiling && (
                      <p><strong>Date of Filing:</strong> {item.dateOfFiling}</p>
                    )}
                    {item.applicationNo && <p><strong>Application No:</strong> {item.applicationNo}</p>}
                    {item.inventors && <p><strong>Inventors:</strong> {item.inventors}</p>}
                    {item.link && (
                      <a href={item.link} target="_blank" rel="noopener noreferrer">
                        View More
                      </a>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Publications;
